export enum DeviceSettingsFeatureToggle {
	DeviceSettings = 'device-settings',

	AudioSmartSettings = 'audio.audio-smart-settings',
	MicrophoneSettings = 'audio.microphone-settings',

	PowerSmartStandBy = 'power.standby-settings',
	PowerBatterySettings = 'power.battery-settings',
	PowerSettings = 'power.power-settings',
	EnergyStar = 'power.energy-star',
	PowerSmartSettings = 'power.power-smart-settings',
	PowerDPMPowerSettings = 'power.dpm-power-settings',

	InputAndAccessoriesIntelligentKeyboard = 'inputAndAccessories.intelligent-keyboard',

	DisplayAndCameraDisplay = 'display-and-camera.display',
	DisplayAndCameraCamera = 'display-and-camera.camera',

	SmartAssistIntelligentScreen = 'smart-assist.intelligent-screen',
	SmartAssistActiveProtectionSystem = 'smart-assist.active-protection-system-settings',
	SmartAssistIntelligentSecurity = 'smart-assist.intelligent-security-settings',
}

export enum FeatureToggle {
	GiveFeedback = 'giveFeedback',
}
